import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IconTooltipButton from '../../../button/IconTooltipButton';
import { Link, useNavigate } from 'react-router-dom';
import MaestroLogo from '../../../MaestroLogo';
import HelpModal from './HelpModal';
import TenantInfo from './TenantInfo';
import UserSessionInfo from './UserSessionInfo';
import { toggleMenu } from '../../../../store/actions/menuActions';
import AlertSaveButton from '../../../button/AlertSaveButton';
import { signOut } from '../../../../services/auth/auth.service';
import { clearApp } from '../../../../store/actions/app.actions';

const Header = () => {
  const [openHelp, setOpenHelp] = React.useState(false);
  const handleOpenHelpModal = () => setOpenHelp(true);
  const handleCloseHelpModal = () => setOpenHelp(false);
  const user = useSelector((state) => state?.session?.user || {});
  const permissions = useSelector((state) => state?.session?.permissions || {});
  const alertSave = useSelector((state) => state?.alert?.save || {});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onLogout = async () => {
    dispatch(clearApp());
    navigate('/');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userSession');
    await signOut();
  };

  const onToggleMenu = () => {
    if (user?.roles?.every((role) => role.name !== 'Parent')) {
      dispatch(toggleMenu());
    }
  };

  const onRedirect = (pathname) => {
    navigate(pathname);
  };

  useEffect(() => {
    if (!localStorage.getItem('accessToken') || !localStorage.getItem('userSession')) {
      onLogout();
    }
  }, []);

  return (
    <header className='px-4 bg-white shadow'>
      <div className='flex items-center justify-start gap-4'>
        {!user?.roles?.every((role) => role.name === 'Parent') && (
          <IconTooltipButton
            title='Toggle menu'
            icon='bars'
            onClick={onToggleMenu}
            color='primary'
            classNameIcon='text-xl'
          />
        )}
        <Link to='/dashboard'>
          <MaestroLogo className='h-7' />
        </Link>
      </div>
      <div className='header-area text-primary'>
        <TenantInfo />
        <UserSessionInfo />
        <div className='flex justify-center gap-2 items-center px-4'>
          {/* Help Button - patrón consistente con otros botones */}
          {permissions.help && (
            <AlertSaveButton
              type='icon'
              title='Help'
              icon='question-circle'
              classNameIcon='text-xl'
              color='primary'
              onDontSave={handleOpenHelpModal}
            />
          )}
          <AlertSaveButton
            submodule={alertSave.module}
            type='icon'
            title='Profile'
            icon='user-circle'
            classNameIcon='text-xl'
            color='primary'
            onDontSave={() => onRedirect(`/dashboard/profile`)}
          />
          <AlertSaveButton
            submodule={alertSave.module}
            type='icon'
            title='Sign out'
            icon='sign-out-alt'
            classNameIcon='text-xl'
            color='primary'
            onDontSave={onLogout}
          />
        </div>
      </div>
      <HelpModal open={openHelp} onClose={handleCloseHelpModal} />
    </header>
  );
};

export default Header;
